"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const InputRange = props => {
  const {
    value = 0,
    onChange,
    orientation = 'horizontal',
    ariaLabel = '',
    type = 'AngularSlider',
    step = 1
  } = props;
  const isHorizontal = orientation === "horizontal";
  const AngularSlider = (0, _styles.styled)(_material.Slider)(() => ({
    color: '#DCDCE4',
    height: isHorizontal ? 8 : '100%',
    '& .MuiSlider-rail': {
      opacity: 1
    },
    '& .MuiSlider-track': {
      border: 'none'
    },
    '& .MuiSlider-thumb': {
      height: isHorizontal ? 32 : 8,
      width: isHorizontal ? 8 : 32,
      backgroundColor: '#1CE783',
      borderRadius: 0,
      '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
        boxShadow: 'inherit'
      },
      '&:before': {
        display: 'none'
      }
    },
    '& .MuiSlider-valueLabel': {
      display: 'none'
    }
  }));
  const getStyledSlider = (0, _react.useCallback)(() => {
    switch (type) {
      case 'AngularSlider':
        return AngularSlider;
      default:
        return _material.Slider;
    }
  }, [type]);
  const StyledSlider = getStyledSlider();
  const _onChange = (0, _react.useCallback)((_, v) => onChange(v), [onChange]);
  return /*#__PURE__*/_react.default.createElement(StyledSlider, {
    step: step,
    "aria-label": ariaLabel,
    orientation: orientation
    // getAriaValueText={valuetext}
    ,
    valueLabelDisplay: "auto",
    value: value,
    onChange: _onChange
  });
};
var _default = exports.default = InputRange;